var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "col-12 bg-gray2" }, [
      _c("div", { staticClass: "h4 mb-0" }, [
        _vm._v("\n            " + _vm._s(_vm.deviceDto.title) + "\n        "),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "card my-1" },
      _vm._l(_vm.deviceDto.items, function (item, index) {
        return _c("CartPageItem", {
          key: item.offerName
            ? item.offerName
            : "cart-page-device-item-" + index,
          attrs: { dto: item },
          on: {
            "remove-item-from-cart-in-progress": function ($event) {
              return _vm.$emit("remove-item-from-cart-in-progress", $event)
            },
            "remove-item-from-cart-success": function ($event) {
              return _vm.$emit("remove-item-from-cart-success", $event)
            },
            "remove-item-from-cart-error": function ($event) {
              return _vm.$emit("remove-item-from-cart-error", $event)
            },
          },
        })
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }